import React, { ComponentPropsWithRef } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

export const Input = ({
  register,
  ...rest
}: ComponentPropsWithRef<'input'> & { register: UseFormRegisterReturn }) => {
  return (
    <>
      <input
        {...rest}
        className="text-base border-gray mt-2 py-2 px-4 border rounded-sm border-solid bg-lawguebg w-full bg-[transparent]"
        {...register}
      />
    </>
  )
}
